import { createI18n, type I18nOptions } from 'vue-i18n'

import en from '@/i18n/en.json'
import es from '@/i18n/es.json'
import fr from '@/i18n/fr.json'

const options: I18nOptions = {
  legacy: false,
  locale: navigator.language.split('-').at(0) ?? 'en',
  fallbackLocale: 'en',
  messages: { en, es, fr },
}

export default createI18n<false, typeof options>(options)
